// extracted by mini-css-extract-plugin
export default {"payment-method-tabs":"PaymentMethodTabs-module__payment-method-tabs--L2Xov","payment-method-tabs__tab":"PaymentMethodTabs-module__payment-method-tabs__tab--IgwTJ"};